import { GET_ADS_BY_SIZE_INIT } from "../actionTypes/ads.actionTypes";

export const getAdsBySize = () => {
  return { type: GET_ADS_BY_SIZE_INIT };
};
